
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.217 13.629v4.9l4.604-2.442-4.604-2.458z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16zm24.328-3.22s-.167-1.202-.678-1.732c-.585-.626-1.233-.69-1.599-.727l-.108-.011c-2.385-.177-5.962-.177-5.962-.177h-.008s-3.577 0-5.962.177a5.374 5.374 0 01-.109.011c-.366.037-1.014.1-1.599.727-.51.53-.677 1.731-.677 1.731s-.17 1.412-.17 2.823v1.323c0 1.412.17 2.823.17 2.823s.166 1.202.677 1.73c.538.577 1.216.66 1.648.714.089.01.167.02.232.032 1.363.134 5.794.176 5.794.176s3.58-.005 5.966-.182a5.27 5.27 0 01.11-.012c.366-.036 1.013-.101 1.597-.727.51-.53.678-1.731.678-1.731s.17-1.411.17-2.823v-1.323c0-1.411-.17-2.823-.17-2.823z","fill":"currentColor"}})])
          )
        }
      }
    